import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeleteRailPointData } from 'src/app/page/masterdata/rail-points/rail-points.component';

@Component({
    selector: 'app-delete-rail-point',
    templateUrl: './delete-rail-point.component.html',
    styleUrls: ['./delete-rail-point.component.scss'],
    standalone: false // NOSONAR
})
export class DeleteRailPointComponent implements OnInit {
  content;
  id;
  pageName;

  constructor(public dialogRef: MatDialogRef<DeleteRailPointComponent>, 
    @Inject(MAT_DIALOG_DATA) public dataStore: DeleteRailPointData) {
      if(this.dataStore.page == 'rail point'){ // NOSONAR
        this.pageName = "Rail Point";
        this.content = this.dataStore.railPoint;
        this.id = this.dataStore.id;
      }
  }

  ngOnInit(): void { // NOSONAR 

  }
  close(): void {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  public saveClick() {    
    this.dialogRef.close({data:this.id});

  }
}
